import { chakra } from '@chakra-ui/react';

import { panelRecipe } from '../../theme/recipes/panel';

/**
 * Плита: объект, контейнер или вложенный блок. Роли и причины — в самом рецепте
 * (`theme/recipes/panel.ts`); здесь только привязка рецепта к элементу.
 *
 * `div`, а не `span`: плита всегда блочная и почти всегда сама раскладывает детей — поэтому её
 * спокойно можно превращать во флекс-контейнер обычными пропами, как любой `Box`.
 */
export const Panel = chakra('div', panelRecipe);
